import { LimePageHeader } from "@/Components/LimePageHeader";
import { Tab, Tabs } from "@heroui/react";
import { t } from "@lingui/core/macro";
import { useMemo } from "react";
import { Outlet, useNavigate, useSearchParams } from "react-router";

export const Subscriptions = () => {
  const navigate = useNavigate();
  const [_, setSearchParams] = useSearchParams();

  const tabs = [
    {
      label: t`Naročnine`,
      value: "",
    },
    {
      label: t`Oznake`,
      value: "tags",
    },
    {
      label: t`Kategorije`,
      value: "categories",
    },
  ];

  const activeTab = useMemo(() => {
    const pathname = window.location.pathname;
    const tab = pathname
      .split("/")
      .find((p) => p === "tags" || p === "categories");
    return tab ?? "";
  }, [window.location.pathname]);

  const rightSection = useMemo(() => {
    if (activeTab === "") {
      return {
        label: t`Ustvari naročnino`,
        onClick: () => {
          // setSelectedSubscriptionId(undefined);
          // onOpenSubscriptionModal();

          setSearchParams((prev) => {
            prev.set("sid", "-1");
            return prev;
          });
        },
        identifier: "create-subscription-button",
      };
    }

    return undefined;
  }, [activeTab]);

  return (
    <>
      <LimePageHeader title={t`Naročnine`} rightSection={rightSection} />

      <div className="px-4 md:px-8">
        <Tabs
          variant="underlined"
          selectedKey={activeTab}
          onSelectionChange={(value) => {
            navigate(value as string, {
              relative: "path",
            });
          }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.value} value={tab.value} title={tab.label}></Tab>
          ))}
        </Tabs>
      </div>

      <div className="mt-2 px-4 md:px-8">
        <Outlet />
      </div>
    </>
  );
};
